module.exports = __webpack_public_path__ + "img/bg-about-bottom.b6d62d53.png";